<script setup>
import { useCareVisitDashboardFilters } from '@/composables/useCareVisitDashboardFilters'
import DashboardFilterBar from '@/views/care-visit/dashboard/DashboardFilterBar.vue'
import DailyTrafficChart from '@/views/care-visit/traffic/DailyTrafficChart.vue'
import TrafficByFloorChart from '@/views/care-visit/traffic/TrafficByFloorChart.vue'
import TrafficWeeklyHeatmap from '@/views/care-visit/traffic/TrafficWeeklyHeatmap.vue'

definePage({
  meta: {
    name: 'Traffic Dashboard',
    subject: 'care_visit.menu',
    action: 'traffic',
  },
})

// Same filter state and defaults as the Dashboard page, so a supervisor
// moving between the two sees the same range and floors.
const {
  selectedFloorIds,
  selectedVisitorType,
  dateRange,
  datePickerConfig,
  floors,
  visitorTypes,
  debouncedFilters,
} = useCareVisitDashboardFilters()
</script>

<template>
  <div>
    <div class="d-flex flex-column flex-md-row justify-space-between align-start align-md-center gap-4 mb-6">
      <div>
        <h1 class="text-h4 font-weight-bold">
          Traffic Dashboard
        </h1>
        <p class="text-body-1 text-medium-emphasis mb-0">
          How many people are inside, when, and on which floor
        </p>
      </div>

      <DashboardFilterBar
        v-model:floor-ids="selectedFloorIds"
        v-model:visitor-type="selectedVisitorType"
        v-model:date-range="dateRange"
        :floors="floors"
        :visitor-types="visitorTypes"
        :date-picker-config="datePickerConfig"
      />
    </div>

    <VRow>
      <VCol cols="12">
        <TrafficWeeklyHeatmap :filters="debouncedFilters" />
      </VCol>

      <VCol cols="12">
        <DailyTrafficChart :filters="debouncedFilters" />
      </VCol>

      <VCol cols="12">
        <TrafficByFloorChart :filters="debouncedFilters" />
      </VCol>
    </VRow>
  </div>
</template>
